import "./styles.less";
import { useLocationTag } from "./LocationTag.hook";
import usePropertyData from "src/hooks/propertyData/usePropertyData";

export function LocationTag({ id, mode = "auto", hideAddress = false }) {
	const { address, showAddress, loading, error } = useLocationTag({
		id,
		mode,
	});
	const { listing } = usePropertyData();

	if (error || loading) return null;

	return (
		<span className="property-location-tag" >
			{(!hideAddress && showAddress && address) &&
				<p style={{ margin: '0' }} className="body body-1 body-regular medium">
					{listing?.locations?.locality && listing?.locations?.locality[0]?.name}{listing?.locations?.state && `, ${listing?.locations?.state[0]?.name}`}
				</p>
			}
			<p className="body body-1 body-regular medium">
				{listing?.locations?.neighbourhood && listing?.locations?.neighbourhood[0]?.name}{listing?.locations?.state && `, ${listing?.locations?.state[0]?.name}`} </p>
		</span>
	);
}


